export const QB_TRACKING_SUFFIX = '/QB';
